import React from 'react';
import ReactImageMagnify  from 'react-image-magnify';

const ZoomableImage = ({ imageUrl, zoomWidth, zoomHeight }) => {
  const imageProps = {
    smallImage: {
      alt: 'Product',
      isFluidWidth: true,
      src: imageUrl,
    },
    largeImage: {
      src: imageUrl,
      width: zoomWidth,
      height: zoomHeight,
    },
    enlargedImagePosition: 'beside',
  };

  return <ReactImageMagnify  {...imageProps} />;
};

export default ZoomableImage;